import Skeleton from "react-loading-skeleton";

import { Badge2 } from "@/ui2/atoms/Badge";
import type { CosignatureStatusParam } from "@/core/types/(api)/cosignature";
import { Tab2 } from "@/ui2/atoms/Tab";
import { useNeedsReviewQueue } from "@/features/cosignature/api/queries/useNeedsReviewQueue";

type NeedsReviewTabProps = {
  cosignature_status?: CosignatureStatusParam;
  supervisor_id?: string;
};

export function NeedsReviewTab({ cosignature_status, supervisor_id }: NeedsReviewTabProps) {
  const { data, isFetching, isLoading, isPreviousData } = useNeedsReviewQueue({
    cosignature_status,
    supervisor_id,
  });

  // keepPreviousData masks filter changes as `isLoading: false` — treat showing
  // the stale (previous-filter) count while refetching as loading too
  const isCountLoading = isLoading || (isFetching && isPreviousData);

  return (
    <Tab2 id="needs-review">
      {({ isSelected }) => (
        <>
          Needs Review
          {isCountLoading ? (
            <CounterBadgeSkeleton />
          ) : (
            <Badge2
              appearance={isSelected ? "solid" : "outline"}
              size="xs"
              variant={isSelected ? "bright-green" : "neutral"}
            >
              {data?.total_item_count ?? 0}
            </Badge2>
          )}
        </>
      )}
    </Tab2>
  );
}

function CounterBadgeSkeleton() {
  return (
    <div className="tw:leading-none">
      <Skeleton className="tw:rounded-xs!" height={16} width={20} />
    </div>
  );
}
